import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import AccountAnimated from "../../../../assets/img/payment/accountHead.svg";
import {OtherPayment} from "../../../../redux/actions/Cart.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import ProductAutoComplete from "../../../Module/SalesPurchase/Components/ProductAutoComplete";

export default function AccountHead(props) {
  const [accountHead, SetaccountHead] = useState(false);
  const [selectedData, SetselectedData] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    ApiConnect.get(`/Module/Accounts/AccountHead/Details`)
      .then((response) => {
        SetaccountHead(response.data);
      })
      .catch((error) => console.log(error));
  }, []);
  const selectedAction = (e) => {
    SetselectedData(e);
    dispatch(OtherPayment("Account", props.total, e.id));
  };
  return (
    <div className="card mb-0">
      <div className="card-body row">
        <div className="col">
          <img src={AccountAnimated} alt="Account Head" width="300" />
        </div>
        <div className="col align-content-center">
          {accountHead ? (
            <div className="form-group">
              <label>Account Head *</label>
              <ProductAutoComplete
                action={selectedAction}
                name="account"
                value=""
                placeHolder="Account Head"
                styleName="form-control input-sm d-block"
                items={accountHead}
              />
            </div>
          ) : (
            ""
          )}
          <address>
            <br />
            <strong>{selectedData.group || ""}</strong>
            <br />
            <b>Address: </b>
            {selectedData.address || ""}
            <br />
            <b>Contact: </b> {selectedData.contact || ""}
            <br />
            <strong>Due: {selectedData.balance || ""}/</strong>
            <br />
            <b>Last Credit: </b>
            {selectedData.lastCredit || ""}
            <br />
            <b>Last Debit: </b>
            {selectedData.lastDebit || ""}
          </address>
        </div>
      </div>
    </div>
  );
}
